import React, { useEffect, useState } from "react";
import CustomModal from "../CustomModal/CustomModal";
import { useTranslation } from "react-i18next";
import QrCode from "../../pages/QrCodeInstall/QrCode/QrCode";
import Modal from "react-bootstrap/Modal";
import { Row, Col } from "react-bootstrap";
import appConfig from "../../constants/config";
import { translate } from "../../utils/translateUtils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComputer, faMobile } from "@fortawesome/free-solid-svg-icons";
interface InstallPromptFooterProps {
  // installApp: () => void;
  // closeInstallPrompt: () => void;
  platform: string;
  environment: string;
  setEnvironment: React.Dispatch<React.SetStateAction<string | "">>;
  isPWA: () => boolean;
  detectEnvironment: () => void;

}

const InstallPromptFooter: React.FC<InstallPromptFooterProps> = ({
  platform,
  environment,
  setEnvironment,
  isPWA,
  detectEnvironment
}) => {
  const [promptEnable, setPromptEnable] = useState(false);
  const [qrPromptEnable, setQRPromptEnable] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [dismissPrompt, setDismissPrompt] = useState<any>(false);
  const [retryInterval, setRetryInterval] = useState<number>(1000); // Initial delay of 1 second
  const [retryTimeout, setRetryTimeout] = useState<number | null>(null);
  const [t] = useTranslation();
  const isDismissInstallation = localStorage.getItem("dismissInstallation")
    ? localStorage.getItem("dismissInstallation")
    : "false";
  let intervalId: any = null;
  let retryCount = 0; // Counter to track the number of retries
  const maxRetries = 10; // Maximum number of retries

  useEffect(() => {
    const handleBeforeInstallPrompt = (e: any) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setPromptEnable(true);
    };

    const checkAppInstallation = () => {
      detectEnvironment();
      const isAppInstalled = isPWA();
      if (isAppInstalled) {
        console.log("The app is already installed.");
        setDismissPrompt(true);
        setPromptEnable(false);
      } else {
        retryInstallPrompt();
      }
    };

    const retryInstallPrompt = () => {
      intervalId = setInterval(() => {
        if (!deferredPrompt && !dismissPrompt && retryCount < maxRetries) {
          retryCount++;
          console.log(`Retrying install prompt... Attempt ${retryCount}`);
          const event = new CustomEvent("beforeinstallprompt");
          window.dispatchEvent(event);
        }
        if (retryCount >= maxRetries) {
          console.log("Max retries reached. Stopping retry attempts.");
          clearInterval(intervalId);
        }
      }, 30000);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    checkAppInstallation();

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
      if (intervalId) clearInterval(intervalId);
    };
  }, [deferredPrompt, dismissPrompt]);

  const attemptInstallPrompt = () => {
    if (deferredPrompt && typeof deferredPrompt.prompt === "function") {
      deferredPrompt.prompt();
      deferredPrompt.userChoice
        .then((choiceResult: any) => {
          if (choiceResult.outcome === "accepted") {
            console.log("User accepted the install prompt");
            setPromptEnable(false);
            setDeferredPrompt(null); // Clear deferredPrompt after use
          } else {
            console.log("User dismissed the install prompt");
            setPromptEnable(false);
            setDeferredPrompt(null); // Clear deferredPrompt after use
          }
        })
        .catch((error: any) => {
          console.error("Error showing install prompt:", error);
          retryInstallPromptWithBackoff();
        });
    } else {
      console.error("No valid deferred prompt available or prompt is not a function.");
    }
  };

  const retryInstallPromptWithBackoff = () => {
    if (retryInterval < 30000) {
      setRetryTimeout(window.setTimeout(attemptInstallPrompt, retryInterval));
      setRetryInterval((prev) => prev * 2);
    } else {
      console.error("Max retry interval reached. Prompt will not be retried.");
    }
  };

  const qrInstallPrompt = (isOpen: boolean = false) => {
    setQRPromptEnable(isOpen);
  };

  return (
    <>
      <CustomModal
        modalIsOpen={qrPromptEnable}
        handleClose={() => qrInstallPrompt(false)}
        title={translate("Install EEC Mobile App")}
        body={""}
        bodyElement={
          <>
            <Row>
              <Col md={12}>
                <div style={{ width: "100%", height: "100%" }}>
                  <QrCode className={""} />
                </div>
                <br />
              </Col>
              <Col md={12}>
                <center>
                  {" "}
                  <p
                    style={{
                      fontWeight: "bold",
                      fontSize: "18px",
                      color: "darkred",
                    }}
                  >
                    Scan The QR Code
                  </p>
                </center>
              </Col>
              <Col md={12}>
                {/* <p>
                  Scan the QR code above to install <b>EEC</b> as a mobile
                  application. It will open in its own window and integrate with
                  your device features.
                </p> */}
                <div>
                  <div style={{ fontWeight: "bold", fontSize: "15px" }}>
                    To Install EEC app on your mobile :
                  </div>
                  <div style={{ display: "flex" }}>
                    <span style={{ marginRight: "3px", fontWeight: "bold" }}>
                      1.
                    </span>
                    <span style={{ paddingLeft: "3px" }}>
                      Open your camera feature from your mobile.
                    </span>
                  </div>
                  <div style={{ display: "flex" }}>
                    <span style={{ marginRight: "3px", fontWeight: "bold" }}>
                      2.
                    </span>
                    <span style={{ paddingLeft: "3px" }}>
                      Point your mobile device at the QR code.
                    </span>
                  </div>
                  <div style={{ display: "flex" }}>
                    <span style={{ marginRight: "3px", fontWeight: "bold" }}>
                      3.
                    </span>
                    <span style={{ paddingLeft: "3px" }}>
                      Wait for the camera to recognize and scan the QR code.
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
            {/* <br />
                        <Row>
                            <Col md={12}>
                                <div style={{ width: "100%", height: "100%", fontSize: "14px" }}>
                                    <p style={{ fontWeight: "bold", fontSize: "16px" }}>
                                        To Install EEC app on your mobile :
                                    </p>
                                    <p>
                                        <b>1.</b> Open your camera feature on your mobile.
                                    </p>
                                    <p>
                                        <b>2.</b> Point your phone at the screen and scan the QR code.
                                    </p>
                                </div>
                            </Col>
                        </Row> */}
          </>
        }
        buttons={[
          {
            label: "Cancel",
            onClick: () => {
              qrInstallPrompt(false);
            },
            type: "danger",
          },
        ]}
      />
      <div className="footer-content row px-0 mx-0" style={{ zIndex: "9" }}>
        <div className={(platform == "isDesktop" || environment == "web") ? "" : "d-none"}>
          <div className="p-2 py-3 d-flex footer-label justify-content-sm-between align-items-sm-center">
            <div className={(platform == "isDesktop") ? "" : "d-none"}>
              <p className="footer-caption m-0 fw-bold">
                Delivering Growth - in Asia and Beyond
              </p>
            </div>

            <div className="d-flex gap-10 footer-actions">
              <div className="d-flex flex-row flex-sm-column flex-md-row gap-10 justify-content-center align-items-center">
              {platform == "isDesktop" && 
                <div
                  id="installPcAppButton"
                  className={`mobile-app-download-button ${promptEnable ? "" : "d-none"
                    }`}
                  onClick={attemptInstallPrompt}
                >
                  <div
                    className="download mb-sm-3 mb-md-0"
                    style={{ cursor: "pointer" }}
                  >
                    
                      <><FontAwesomeIcon icon={faComputer} />
                        <div className="text">
                          {translate("Install as")}&nbsp;
                          <strong>{translate("PC App")}</strong>
                        </div>
                      </>
                  </div>
                </div>
                }
                {/* {platform == "isDesktop" && */}
                  <div
                    id="installMobileAppButton"
                    className="mobile-app-download-button"
                    onClick={() => {
                      if (platform === "isDesktop") {
                        qrInstallPrompt(true);
                      } else {
                        window.location.href = `${window.location.origin}${appConfig.connectionString.appBaseName}/?qrCode`;
                      }
                    }}
                  >
                    <div
                      className="download mb-sm-3 mb-md-0"
                      style={{ cursor: "pointer" }}
                    >
                      <FontAwesomeIcon icon={faMobile} />
                      <div className="text">
                        {translate("Install as")}&nbsp;
                        <strong>{translate("Mobile App")}</strong>
                      </div>
                    </div>
                  </div>
                {/* } */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InstallPromptFooter;
